import React from "react"
import RoundedContainer from "../../components/RoundedContainer"
import { FibreDescription, FibreHeading } from "../../components/FibreHeading"
import TestimonialList from "./ReviewCard"
import { colorTheme } from "../../data/SrtingConstants"

const ReviewsInternet: React.FC = () => {
  return (
    <RoundedContainer
      className="!py-10 !sm:py-20"
      bgColor={colorTheme.MEDIUM_PURPLE}
    >
      <FibreHeading align="text-center" color="white" content={"Reviews"} />
      <FibreDescription
        align="text-center"
        color="white"
        className="my-5"
        content={"Actual Reviews from Google"}
      />

      <TestimonialList
        testimonials={[
          {
            name: "Adam G, Halifax, Nova Scotia",
            rating: 5,
            description:
              "Purple cow is the only internet provider you need, and the only one you should consider. The internet service itself is fast and reliable - I don't have issues streaming, working from home, etc. Also, the customer service is unmatched. They connect by phone call, text, or video call. That connection is quick, so no long wait times on a phone. I always feel like positive reviews read as generic, but this is the truth. Purple Cow is the best. A+, 10/10, 💯.",
          },
          {
            name: "Shane W, Charlottetown, Prince Edward Island",
            rating: 5,
            description:
              "Not usually the type to post reviews but the service with this group warrants one. From first text to purple cow to streaming our first movie only took 3 days. Everyone was very helpful and set up was a breeze, they even checked our signal strength and did a follow up to make sure we were happy with everything. Thanks to all.",
          },
          {
            name: "Monica R, Dartmouth, Nova Scotia",
            rating: 5,
            description:
              "Honestly, the internet is just as good as any other service in Halifax. In my experience it matches Bell and Eastlink. The customer service has been spectacular for me. That was the real winner. Try calling Bell and it’s a mess of being transferred and wait times… I found it so easy to communicate with Purple Cow customer service.",
          },

          {
            name: "Shelly Mills, Sackville Nova Scotia",
            rating: 5,
            description:
              "Easy to set up. Quality is excellent! I wish I would have switched years ago!! Spent soooo much over the years!! My husband is happy because he can still watch all the sports he wants 👍🏻",
          },
          {
            name: "MJ Love, Windsor Nova Scotia",
            rating: 5,
            description:
              "We set up internet at the cottage again this year and the process was very efficient. Modem arrived quickly, it was working on the day we asked for. Easy to contact them by text and have an answer quickly. Thank you very much for great customer service!",
          },
          {
            name: "Bill Red - Corner Brook Newfoundland",
            rating: 5,
            description:
              "Recently activated internet services with Purple Cow. I must say I have been impressed, communication has been excellent , activation process was easy and you always feel supported throughout the process. Needless to say I’m impressed and will provide a further update once I’ve had an opportunity to test drive the TV services.",
          },
        ]}
      />
    </RoundedContainer>
  )
}

export default ReviewsInternet
